<template>
<div class="container bg-white borda" style="margin-top: 30px; padding: 0px; max-width: 1185px;">
  <form class="p-3">
    <!-- 2ª Etapa Não Contribuinte -->
    
    <div class="mt-3">
      
      <b-row>
        <b-col md="12">
          <router-link  to="/difal"  class="btn btn-primary" style="font-size: 14px" tag="button">
            <i class="fas fa-backward mr-2"></i>Voltar
          </router-link>
          <p  style="font-size: 28px;" class="referencia">{{ titulo }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="text-left">
          <label for="uforigem">UF Origem:</label>
          <b-form-select
            class="select"
            name="uforigem"
            ref="reforigem"
            id="uforigem"
            v-model="objetoReceber.UfOrigem"
            :options="options"
            :value="options.Sigla"
          ></b-form-select>
          <span class="erro" v-if="validacao.Origem">* Preenchimento Obrigatório, escolha um UF</span>
        </b-col>
        <b-col md="6" class="text-left">
          <label for="uforigem">UF Destino:</label>
          <b-form-select
            name="ufdestino"
            class="select"
            ref="refdestino"
            id="ufdestino"
            v-model="objetoReceber.UfDestino"
            :options="options"
            :value="objetoReceber.Sigla"
          ></b-form-select>
          <span class="erro" v-if="validacao.Destino">* Preenchimento Obrigatório, escolha um UF</span>
        </b-col>
      </b-row>

      <b-row class="my-3">
        <b-col md="12" class="text-left">
          <label for="valoroperacao">Valor Total:</label>
        </b-col>
        <b-col md="12">
          <span class="w-tooltip" id="valoroperacaotooltip" v-if="hovertooltip">
            <span class="quadrado"></span>Valor do produto - Frete - Outras Despesas Acessórias – Descontos - IPI
          </span>
          <b-input-group
            type="text"
            @mouseover="hovertooltip = true"
            @mouseleave="hovertooltip = false"
            prepend="R$"
          >
            <input
              name="valoroperacao"
              ref="refvaloroperacao"
              v-money="money"
              id="valoroperacao"
              type="text"
              class="form-control"
              v-model="objetoReceber.ValorTotal"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.ValorTotal">* Preenchimento Obrigatório</span>
        </b-col>
      </b-row>

      <b-row class="my-3">
        <b-col md="6" class="text-left">
          <label for="frete">Alíquota Interna: <span style="font-size:15px"><a href="https://www.lefisc.com.br/ncm/" target="_blank">Consultar</a></span></label>
          <b-input-group type="text" append="%">
            <input
              name="frete"
              id="frete"
              ref="reffrete"
              type="text"
              v-money="porcentagem2"
              maxlength="5"
              class="form-control"
              v-model="objetoReceber.AliquotaInterna"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.AliquotaInterna">* Preenchimento Obrigatório</span>
        </b-col>
        <b-col md="6">
          <label for="despesasacessorias">Fundo de Combate à Pobreza:</label>
          <b-input-group type="text" append="%">
            <input
              type="text"
              v-money="porcentagem"
              ref="refdespesasacessorias"
              maxlength="5"
              name="despesasacessorias"
              id="despesasacessorias"
              class="form-control"
              v-model="objetoReceber.FundoCombatePobreza"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.FundoCombatePobreza">* Campo Inválido</span>
        </b-col>
      </b-row>
        <b-row class="my-3">
        <b-col md="6" class="text-left">
          <label for="reducaobaseinterna">Redução da base interna:</label>
          <b-input-group type="number" append="%">
            <input
              type="text"
              id="reducaobaseinterna"
              min="0"
              v-money="porcentagem"
              maxlength="5"
              class="form-control"
              v-model="objetoReceber.ReInterna"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.ReInterna">* Campo Inválido</span>
        </b-col>
        <b-col md="6">
          <label for="reducaobaseexterna">Redução da base interestadual:</label>
          <b-input-group type="number" append="%">
            <input
              type="text"
              id="reducaobaseexterna"
              min="0"
              v-money="porcentagem"
              maxlength="5"
              class="form-control"
              v-model="objetoReceber.ReInterestadual"
            />
          </b-input-group>
          <span class="erro" v-if="validacao.ReInterestadual">* Campo Inválido</span>
        </b-col>
      </b-row>
      
      <b-row class="my-3">
        <b-col class="text-left">
          <b-form-group class="radiot">
            <b-row>
              <b-col md="6">
                <div v-if="this.$route.params.ID != 13">
                  <h6 class="subtitulo">ICMS</h6>
                  <div class="radio">
                    <b-form-radio
                    clas
                      v-model="objetoReceber.IcmsBool"
                      name="IcmsBool"
                      value="true"
                    >Com ICMS na base</b-form-radio>
                    <b-form-radio
                      v-model="objetoReceber.IcmsBool"
                      name="IcmsBool"
                      value="false"
                    >Sem ICMS na base</b-form-radio>
                  </div>
                </div>
              </b-col>
              <b-col md="6">
                <div>
                  <h6 class="subtitulo">ORIGEM DA MERCADORIA</h6>
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      id="nacional"
                      @click="objetoReceber.Importada = false"
                      name="origemMercadoria"
                      class="custom-control-input"
                    />
                    <label class="custom-control-label" for="nacional">Nacional</label>
                  </div>
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      id="importadaouCIS40"
                      @click="objetoReceber.Importada = true"
                      name="origemMercadoria"
                      class="custom-control-input"
                    />
                    <label
                      class="custom-control-label"
                      for="importadaouCIS40"
                    >Importada ou com conteúdo de importação superior a 40%</label>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="text-right">
          <button
            style="font-size: 14px"
            class="btn btn-danger"
            v-if="reiniciarBool"
            @click.prevent.stop="objetoReceber.zerar(), reiniciarBool = false, botaoTitulo = 'Calcular'"
          >Limpar campos</button>
          <button class="btn btn-success" style="font-size: 14px" @click.prevent.stop="loading = true, enviar()">
            {{ botaoTitulo }}
            <div class="spinner-border text-white loading" v-if="loading" role="status">
              <span class="sr-only">Aguarde...</span>
            </div>
          </button>
        </b-col>
      </b-row>

      <!-- Modal Resultado -->
      <b-modal ref="resultadoID" centered ok-only v-b-modal.modal-sm class="text-center">
        <div class="spinner-border text-primary" v-if="loading" role="status">
          <span class="sr-only">Aguarde...</span>
        </div>
        <h3 v-if="resultado" class="tituloModal d-inline-block">
          Diferencial de Alíquotas:
          <input
            v-money="money2"
            :value="resultado.difal"
            class="w-25 ml-3 resultadoInput"
          />
        </h3>
        <h3 v-if="resultado.fundoCP > 0" class="tituloModal d-inline-block">
          Fundo de Combate a Pobreza:
          <input
            style="font-size:1;"
            v-money="money2"
            :value="resultado.fundoCP"
            class="w-25 ml-3 resultadoInput"
          />
        </h3>
      </b-modal>
      <!-- Modal Resultado FIM -->
    </div>
    <!-- 2ª Etapa Não Contribuinte FIM -->
  </form>
</div>
</template>

<script>
import DifalNC from "../models/DifalNC";
import estados from "../assets/arquivos/estados.json";
import { VMoney } from "v-money";
import service from "../services/serviceCalculoNC";
import { setTimeout } from "timers";
export default {
  directives: { money: VMoney },
  data() {
    return {
      options: estados,
      objetoReceber: new DifalNC(),
      objetoEnviar: new DifalNC(),
      botaoTitulo: "Calcular",
      reiniciarBool: false,
      loading: false,
      hovertooltip: false,
      resultado: {
        difal: 0,
        fundoCP: 0
      },
      validacao: {
        Destino: false,
        Origem: false,
        ValorTotal: false,
        AliquotaInterna: false,
        Icms: false
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */
      },

      money2: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */
      },

      porcentagem: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */
      },

      porcentagem2: {
        decimal: ".",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */
      },

      titulo: "Não contribuinte"
    };
  },
  methods: {
    validarform() {
      if (this.objetoEnviar.UfOrigem) {
        this.validacao.Origem = false;
        if (this.objetoEnviar.UfDestino) {
          this.validacao.Destino = false;
          if (this.objetoEnviar.ValorTotal > 0) {
            this.validacao.ValorTotal = false;
            if (this.objetoEnviar.AliquotaInterna > 0) {
              this.validacao.AliquotaInterna = false;
              if (this.objetoEnviar.IcmsBool || !this.objetoEnviar.IcmsBool) {
                this.validacao.Icms = false;
                return true;
              } else if (!this.objetoEnviar.IcmsBool) {
                this.validacao.Icms = false;
              } else {
                this.validacao.Icms = true;
              }
            } else {
              this.validacao.AliquotaInterna = true;
            }
          } else {
            this.validacao.ValorTotal = true;
          }
        } else {
          this.validacao.Destino = true;
        }
      } else {
        this.validacao.Origem = true;
      }
      return false;
    },
    async enviar() {
      this.objetoEnviar.zerar();
      this.objetoEnviar.UfDestino = this.objetoReceber.UfDestino;
      this.objetoEnviar.UfOrigem = this.objetoReceber.UfOrigem;
      this.objetoEnviar.ValorTotal = this.objetoReceber.ValorTotal;
      console.log( this.objetoEnviar.ValorTotal)
      this.objetoEnviar.AliquotaInterna = this.objetoReceber.AliquotaInterna;
      this.objetoEnviar.FundoCombatePobreza = this.objetoReceber.FundoCombatePobreza;
      this.objetoEnviar.IcmsBool = this.objetoReceber.IcmsBool;
      this.objetoEnviar.Importada = this.objetoReceber.Importada;
      this.objetoEnviar.reducaoDeBaseExterna = this.objetoReceber.ReInterestadual;
      this.objetoEnviar.reducaoDeBaseInterna = this.objetoReceber.ReInterna;
       this.objetoEnviar.ReInterna = this.objetoReceber.ReInterna;
      this.objetoEnviar.ReInterestadual = this.objetoReceber.ReInterestadual
      
      this.objetoEnviar.reducaoDeBaseInterna = parseFloat(
        this.objetoEnviar.reducaoDeBaseInterna
      );
      this.objetoEnviar.reducaoDeBaseExterna = parseFloat(
        this.objetoEnviar.reducaoDeBaseExterna
      );

      this.objetoEnviar.converter();
      let validadoObjeto = this.objetoEnviar.valida();
      let validadoForm = this.validarform();
      console.log(this.objetoEnviar)
     if (validadoObjeto && validadoForm) {
       console.log(this.objetoEnviar)
        await service.calcularNC(this.objetoEnviar).then(
          res => {
            if (res) {
              this.reiniciarBool = true;
              this.loading = false;

              this.mostrarModalResultado();
              let resultadoDifal = res.data.difal;
              let resultadoFundoCP = res.data.fundoCP;

              this.resultado.difal = this.colocandoMascara(resultadoDifal + "");
              this.resultado.fundoCP = this.colocandoMascara(
                resultadoFundoCP + ""
              );
              this.botaoTitulo = "Calcular novamente";
            }
          },
          erro => {
            //console.error(erro);
            this.loading = false;
          }
          
        );
      } else this.loading = false;
      
    },
    mostrarModalResultado() {
      this.$refs["resultadoID"].show();
    },

    colocandoMascara(string) {
      let indice = 0;

      if (string.includes(".")) {
        indice = string.indexOf(".");
        string = string.substring(0, indice + 3);
      } else {
        string = string + "00";
      }

      let teste = string.substring(indice + 1);

      if (string.includes(".") && teste.length < 2) {
        string = string + "0";
      } else if (string.length <= 2) {
        string = string + "00";
      }

      return string;
    }
  }
};
</script>

<style scoped>

.borda {
  border: 1px solid rgb(236, 235, 235);
}
.w100 {
  width: 100%;
}
.erro {
  color: red;
  font-style: oblique;
  display: block;
}
.w-tooltip {
  background-color: rgb(253, 253, 232);
  color: black;
  border: 1px solid rgb(212, 212, 212);
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  width: 250px;
  height: 55px;
  z-index: 1;
  bottom: 50px;
  font-size: 13px;
}
.container {
  max-width: 1168px;
}
.tituloModal {
  font-size: 18px;
  font-weight: bold;
}
.tituloModal2 {
  font-size: 16px;
}
.resultadoInput {
  border: none;
}
.quadrado {
  background-color: black;
  height: 20px;
  width: 20px;
  content: normal;
  display: inline-block;
  position: absolute;
  bottom: -10px;
  left: 45%;
  transform: rotateZ(45deg);
  background-color: rgb(253, 253, 232);
  border-right: 1px solid rgb(212, 212, 212);
  border-bottom: 1px solid rgb(212, 212, 212);
}

.subtitulo {
  font-weight: bold;
  font-size: 14px;
}

.voltar {
  color: rgb(175, 175, 175);
  text-decoration: none;
  font-weight: bold;
}

.loading {
  height: 16px;
  width: 16px;
  font-size: 10px;
}

.select:hover {
cursor: pointer;
}

.referencia {
  color: rgb(0, 0, 0);
  border-top: 0.8px solid rgb(240, 240, 240);
  display: block;
  margin-top: 20px;
  padding-top: 2px;

}

b-form-group b-form-radio {
  display: none;
}


</style>


// WEBPACK FOOTER //
// src/components/campoFormularioNC.vue